import React, { useEffect, useState } from "react";
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'

import {
  ListsWidget3,
  TilesWidget4,
  TilesWidget5,
} from '../../../_metronic/partials/widgets'
import { VisaListRecordCount } from './list/VisaListRecordCount'
import { VisaInquiryCount } from './list/VisaInquiryCount'
import { VisaFilterForm } from './list/VisaFilterForm'
// import { ListFollowupRecord } from './list/listFollowupRecord'

import { VisaDashboardQueryResponce } from './core/_models'
import { getvisadashborddata } from './core/_requests'
import { VisaListFollowupRecord } from "./list/VisaListFollowupRecord";
import { useAuth } from "../../modules/auth";
import { VisaListDateRecord } from "./list/visaListDateRecord";
import { VisaPointList } from "./list/visaPointList";
import { ToDoListRecord } from "./list/toDoListRecord";
import { AssignTaskRecord } from "./list/assignTaskRecord";

type Props = {
  heading?: string
  total_count?: string
  route_heading?: string
  count?: any
  name?: string
}

const VisaDashboardPage: React.FC<Props> = ({ heading, total_count, route_heading, count, name }) => {
  const [visadashboard, setVisaDashboard] = useState<VisaDashboardQueryResponce>() as any;
  const [visadashboardloading, setVisaDashboardLoading] = useState(false);
  const [visafilterCount, setVisaFilterCount] = useState<string>("");
  useEffect(() => {
    getvisadashborddata('').then((result) => {
      setVisaDashboard(result);
      setVisaDashboardLoading(true);
    });
  }, []);
  const handleFilterSubmit = (filters: any) => {
    const query = Object.keys(filters)
      .map((key) => `${key}=${filters[key]}`)
      .join("&");
    setVisaFilterCount(query);
    getvisadashborddata(query).then((result) => {
      setVisaDashboard(result);
    });
  };
  console.log('visafilterCount', visafilterCount)
  const { currentUser } = useAuth();
  const user_role = currentUser?.user;
  let routeElements;

  if (user_role && user_role.roles && user_role.roles.length > 0) {
    // const slugs = user_role.roles[0].slug;
    const slugs: any[] = [];
    user_role.roles.forEach(role => {
      slugs.push(role.slug);
    });

    console.log('slug', visadashboard?.data?.['visa_pastactive_followup'])
    if (slugs.includes('SalesTeam') || slugs.includes('') || slugs.includes('Partner') || slugs.includes('Employee')) {
      routeElements = (
        <>
          <div className='col-xl-6 '>
            <VisaInquiryCount
              className='card-xxl-stretch bg-primary'
              svgIcon='/media/icons/duotune/general/gen025.svg'
              titleClass='text-white'
              descriptionClass='text-white'
              iconClass='svg-icon-white'
              title={visadashboard?.data?.inquirycount}
              href={`${process.env.REACT_APP_HOME_PAGE}dashboard`}
              description='Total Inquiries'
            />
          </div>
        </>
      )
    }
  }

  return (
    <>
      <div>
        <div className='row g-5 g-xl-12 mt-2'>
          <div className='col-xl-12'>
            <div className='row gx-5 gx-xl-40 mb-5 mb-xl-4'>
              <div className='col-xl-3'>
                {/* < TilesWidget2 className='card-xl-stretch mb-5 mb-xl-8' />  */}
                <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8 pt-lg-20'>
                  {routeElements}
                  <div className='col-xl-6 '>
                    <VisaInquiryCount
                      className='card-xxl-stretch bg-body'
                      svgIcon='/media/icons/duotune/general/gen002.svg'
                      titleClass='text-dark'
                      descriptionClass='text-muted'
                      iconClass='svg-icon-success'
                      href={`${process.env.REACT_APP_HOME_PAGE}visadashboard`}
                      title={visadashboard?.data?.visafilecount}
                      description='Total Visa File'
                    />
                  </div>

                </div>
              </div>
              <div className='col-xl-9'>
                {
                  visadashboardloading &&
                  <VisaFilterForm onVisaFilterSubmit={handleFilterSubmit} className='card-xl-stretch' />
                }
              </div>
            </div>
          </div>
        </div>
        <div className='row gy-5 gx-4'>
          {visadashboard?.data?.['visaproducts'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="PRODUCT TYPE" filter={visafilterCount} name="product_Id" emptyarray={visadashboard?.data?.['productEmpty']} emptycount={visadashboard?.data?.['productEmptyCount']} data={visadashboard?.data?.['visaproducts']} count={visadashboard?.data?.['visa_product_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['visacategoryproducts'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="PRODUCT CATEGORY" filter={visafilterCount} name="product_cate_Id" emptyarray={visadashboard?.data?.['productEmpty']} emptycount={visadashboard?.data?.['productEmptyCount']} data={visadashboard?.data?.['visacategoryproducts']} count={visadashboard?.data?.['visa_productcategory_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}


          {visadashboard?.data?.['filestage'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="FILE STAGE" filter={visafilterCount} name="visa_FileStage_Id" data={visadashboard?.data?.['filestage']} emptyarray={visadashboard?.data?.['fileStageEmpty']} emptycount={visadashboard?.data?.['fileStageEmptyCount']} count={visadashboard?.data?.['visa_filestage_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}


          {visadashboard?.data?.['filestatus'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="FILE STATUS" filter={visafilterCount} name="visa_FileStatus_Id" data={visadashboard?.data?.['filestatus']} emptyarray={visadashboard?.data?.['fileStatusEmpty']} emptycount={visadashboard?.data?.['fileStatusEmptyCount']} count={visadashboard?.data?.['visa_filestatus_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}


          {visadashboard?.data?.['nbpartner'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="NB/PARTNER" filter={visafilterCount} NBcount={visadashboard?.data?.['nbPartnerEmptyCount']} name="visa_NbPartner_Id" data={visadashboard?.data?.['nbpartner']} count={visadashboard?.data?.['visa_nbpartner_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}


          {visadashboard?.data?.['salesexecutive'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="SALES EXECUTIVE" filter={visafilterCount} name="visa_SalesExe_Id" data={visadashboard?.data?.['salesexecutive']} emptyarray={visadashboard?.data?.['salesExecutiveEmpty']} emptycount={visadashboard?.data?.['salesExecutiveEmptyCount']} count={visadashboard?.data?.['visa_salesexecutive_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}


          {visadashboard?.data?.['fileexecutive'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="FILE EXECUTIVE" filter={visafilterCount} name="visa_FileExe_Id" data={visadashboard?.data?.['fileexecutive']} emptyarray={visadashboard?.data?.['fileExecutiveEmpty']} emptycount={visadashboard?.data?.['fileExecutiveEmptyCount']} count={visadashboard?.data?.['visa_fileexecutive_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['visaassignby'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="VISAFILE ASSIGN BY" filter={visafilterCount} name="visa_VisaAssignBy_Id" data={visadashboard?.data?.['visaassignby']} emptyarray={visadashboard?.data?.['visaAssignByEmpty']} emptycount={visadashboard?.data?.['visaAssignByEmptyCount']} count={visadashboard?.data?.['visa_visaassignby_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['visacountry'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="COUNTRY WISE" data={visadashboard?.data?.['visacountry']} filter={visafilterCount} name="visa_Country_Id" emptyarray={visadashboard?.data?.['countryEmpty']} emptycount={visadashboard?.data?.['countryEmptyCount']} count={visadashboard?.data?.['visa_visacountry_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['point_field'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaPointList heading="USER POINTS" data={visadashboard?.data?.['point_field']} count={visadashboard?.data?.['point_field_total']} filter={visafilterCount} name="visa_point" className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['userintake'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="INTAKE" filter={visafilterCount} name="visa_intake_id" data={visadashboard?.data?.['userintake']} emptyarray={visadashboard?.data?.['userIntakeEmpty']} emptycount={visadashboard?.data?.['userIntakeEmptyCount']} count={visadashboard?.data?.['userintake_total']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['vendor_detail'] && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListRecordCount heading="VENDOR" data={visadashboard?.data?.['vendor_detail']} filter={visafilterCount} name="vendor_Id" className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['passport_expiry'] && (
            <div className='col-lg-6 col-xl-4 col-xxl-3'>
              <VisaListDateRecord heading="PASSPORT EXPIRES (IN 3 MONTHS)" name="passport_exp" data={visadashboard?.data?.['passport_expiry']} filter={visafilterCount} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {visadashboard?.data?.['language_expire'] && (
            <div className='col-lg-6 col-xl-5 col-xxl-5'>
              <VisaListDateRecord heading="LANGUAGE EXPIRES (IN 3 MONTHS)" data={visadashboard?.data?.['language_expire']} filter={visafilterCount} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}


          {(visadashboard?.data?.['visa_with_followup'] !== undefined || visadashboard?.data?.['inquiry_without_followup'] !== undefined) && (
            <div className='col-lg-4 col-xl-4 col-xxl-3'>
              <VisaListFollowupRecord heading="VISA FOLLOWUP" name="visa_followup_option" filter={visafilterCount} followup_past_active={visadashboard?.data?.['visa_pastactive_followup']} followup_yes={visadashboard?.data?.['visa_with_followup']} followup_no={visadashboard?.data?.['visa_without_followup']} followup_active={visadashboard?.data?.['visa_active_followup']} followup_deactive={visadashboard?.data?.['visa_deactive_followup']} today_followup={visadashboard?.data?.['visa_today_followup']} today_task={visadashboard?.data?.['visa_today_task']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {(visadashboard?.data?.['visa_today_pending_task_todo'] != undefined) && (
            <div className='col-lg-6 col-xl-4 col-xxl-3'>
              <ToDoListRecord heading="TO DO LIST" name="inq_task_option" filter={visafilterCount} inq_today_pending={visadashboard?.data?.['visa_today_pending_task_todo']} inq_past_pending={visadashboard?.data?.['visa_past_pending_task_todo']} inq_future_pending={visadashboard?.data?.['visa_future_pending_task_todo']} inq_completed_task={visadashboard?.data?.['visa_completed_task_todo']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

          {(visadashboard?.data?.['visa_today_pending_task_assigntask'] != undefined) && (
            <div className='col-lg-6 col-xl-4 col-xxl-3'>
              <AssignTaskRecord heading="ASSIGN TASK" name="inq_assign_task_option" filter={visafilterCount} inq_today_pending={visadashboard?.data?.['visa_today_pending_task_assigntask']} inq_past_pending={visadashboard?.data?.['visa_past_pending_task_assigntask']} inq_future_pending={visadashboard?.data?.['visa_future_pending_task_assigntask']} inq_completed_task={visadashboard?.data?.['visa_completed_task_assigntask']} className='card-xxl-stretch mb-xl-3' />
            </div>
          )}

        </div>
      </div>
    </>
  )
}



const VisaDashboardWrapper = () => {
  const intl = useIntl()


  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <VisaDashboardPage />
    </>
  )
}

export { VisaDashboardWrapper }
